export default {
  mounted(el) {
    const input = el.querySelector("input");
    if (!input) return;

    input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        input.value = input.value.trim();
        input.dispatchEvent(new Event("input"));
      }
    });

    input.addEventListener("blur", () => {
      input.value = input.value.trim();
      input.dispatchEvent(new Event("input"));
    });

    input.addEventListener("paste", () => {
      setTimeout(() => {
        input.value = input.value.trim();
        input.dispatchEvent(new Event("input"));
      }, 0);
    });
  }
};
